import { Flex } from '@chakra-ui/react';

import { CompensationCycleDropdown } from './CompensationCycleDropdown';
import { CompensationLocationDropdown } from './CompensationLocationDropdown';
import { CompensationOrgDropdown } from './CompensationOrgDropdown';

export const CompensationMetaFilters = () => (
  <Flex gap="12px" flexWrap="wrap">
    <CompensationCycleDropdown />
    <CompensationOrgDropdown />
    <CompensationLocationDropdown />
  </Flex>
);
